<div id="dashboard-project" class="page-layout simple right-sidenav" fxLayout="row" style="height: 100%"
  perfect-scrollbar>


  <!-- CENTER -->
  <div class="center" fxFlex style="height: 100%" perfect-scrollbar>

    <!-- HEADER -->

    <!-- <div class="header thin-header mat-accent-bg p-12 p-sm-24" fxLayout="column" fxLayoutAlign="space-between">

      <div fxFlex="" fxLayoutAlign="start center" style="margin:-10px;">
        <mat-icon class="logo-icon" *eguardIfOnDom>dashboard</mat-icon>&nbsp;&nbsp;
        <span class="logo-text h1">Dashboard</span>
      </div>
      <div fxLayout="row">
      </div>
    </div> -->

    <!-- / HEADER -->
    <div class="checkrAlert" *ngIf="role === 'GUARDIAN' && userDetails.background_status === 'new'">
      <span>Your verification process is pending! <a (click)="submitDetails()">click here</a> to submit.</span>
    </div>
    <!-- <div class="checkrAlert" *ngIf="role === 'GUARDIAN' && userDetails.background_status === 'pending'">
      <span>Your background verification process status is pending! <a (click)="submitDetails()">click here</a> to view
        details.</span>
      <mat-icon (click)="checkrId = 1">clear</mat-icon>
    </div> -->
    <!-- CONTENT -->

    <div class="content">
      <mat-tab-group dynamicHeight>
        <div *ngFor="let tab of userTabs">
          <mat-tab
            *ngIf="userRole.toLowerCase() !== 'guardian' || (userRole.toLowerCase() === 'guardian' && tab.title.toLowerCase() !== 'new petition')">

            <ng-template mat-tab-label>
              {{ tab.title }}&nbsp;&nbsp;
              <span class="badge" *ngIf="tab.title.toLowerCase() === 'alerts' && alertBadge">{{alertBadge}}</span>
            </ng-template>

            <div [ngSwitch]="tab.section">

              <div *ngSwitchCase="'caseList'">
                <caseList [mode]="tab.value"></caseList>
              </div>

              <div *ngSwitchCase="'recentActivity'">
                <recentActivity></recentActivity>
              </div>

              <div *ngSwitchCase="'alerts'">
                <alertList (alertLength)="getAlertListLength($event)"></alertList>
              </div>

              <div *ngSwitchCase="'newPetition'">
                <newPetition></newPetition>
              </div>

            </div>

          </mat-tab>
        </div>

      </mat-tab-group>
    </div>
    <!-- / CONTENT -->

  </div>
  <!-- / CENTER -->

</div>



// WEBPACK FOOTER //
// ./src/app/main/content/dashboard/dashboard.component.html